import { Phone, MessageCircle, MapPin, Mail } from "lucide-react";

export function Footer() {
  return (
    <footer className="mt-24 border-t border-border bg-[#F0EBE1]">
      <div className="max-w-7xl mx-auto px-5 md:px-8 py-12 grid md:grid-cols-4 gap-8">
        <div className="md:col-span-2">
          <div className="font-display text-2xl text-primary">Maurizi S.r.l.s.</div>
          <div className="text-xs tracking-widest uppercase text-foreground/60 mt-1">parquet · scale · ringhiere · infissi</div>
          <p className="text-sm text-foreground/70 mt-4 max-w-sm">Artigiani del legno e del ferro dal 1950. Realizziamo, installiamo e ripariamo scale, ringhiere, parquet e infissi su misura.</p>
          <div className="text-xs text-foreground/60 mt-4">
            P.IVA <span className="font-mono">02516470511</span>
          </div>
        </div>
        <div>
          <div className="text-sm font-semibold mb-3">Contatti</div>
          <ul className="text-sm text-foreground/70 space-y-2">
            <li className="flex items-start gap-2"><Mail className="h-4 w-4 mt-0.5 shrink-0" /><a href="mailto:info@maurizisrls.com" className="hover:text-primary">info@maurizisrls.com</a></li>
            <li className="flex items-start gap-2"><MessageCircle className="h-4 w-4 mt-0.5 shrink-0 text-emerald-600" /><a href="https://wa.me/393357810986" target="_blank" rel="noreferrer" className="hover:text-primary" data-testid="footer-whatsapp">WhatsApp 335 781 0986</a></li>
            <li className="flex items-start gap-2"><MapPin className="h-4 w-4 mt-0.5 shrink-0" /><span>Via Nazionale 84<br/>52019 Pergine Valdarno (AR)</span></li>
          </ul>
        </div>
        <div>
          <div className="text-sm font-semibold mb-3">Orari</div>
          <ul className="text-sm text-foreground/70 space-y-2">
            <li>Lun–Ven · 8:00–18:00</li>
            <li>Sab · 8:00–13:00</li>
            <li>Domenica chiuso</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-border py-4 text-center text-xs text-foreground/50">
        © {new Date().getFullYear()} Maurizi S.r.l.s. · <a href="/privacy" className="hover:text-primary">Privacy</a> · <a href="/cookie" className="hover:text-primary">Cookie</a>
      </div>
    </footer>
  );
}
